import { controls } from "../../controls";

const rp605 = {
  label: "CCB 5.1-Non Agri",
  pageLabel: "CCB 5.1-Non Agri",
  starting: true,
  url: "rp605",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT CCB-5.1\n Cash Credit Limits to Marketing/ Weavers/ Processing/ Consumer etc. Societies Sanctioned since the Date of Last Inspection",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Name of the Society",
        accessor: "society_name",
        rwidth:"*"
      },
      
      {
        Header:"Date of Sanction / Renewal",
        accessor: "renewal_date",   
        type:"date",
        width: 150
        
      },

      {
        Header:"Net Disposable Resources at the time of Sanction / Renewal ->> Date",
        accessor: "net_disposabe_date",
        type:"date",
        width: 190
        
      },

      {
        Header: "Net Disposable Resources at the time of Sanction / Renewal ->> Amount",
        accessor: "net_disposabe_amt",   
        width: 190,           
        type:"currency"
        
      },

      {
        Header: "Limit Sanctioned",
        accessor: "limit_sanctioned",
        width: 100,
        type:"currency"
      
      },

      {
        Header:"Period for which Sanctioned / Renewed ->> From",
        accessor: "sanction_date",
        type:"date",
        width: 190
        
      },

      {
        Header:"Period for which Sanctioned / Renewed ->> To",
        accessor: "exp_date" ,
        type:"date",
        width: 190
        
      },

      {
        Header: "Purpose",
        accessor: "purpose",   
        width: 100
        
      },

      {
        Header: "Margin Prescribed %",
        accessor: "margin", 
        width: 150,             
        type:"currency"
        
      },

      {
        Header: "Outstanding",
        accessor: "outstanding",
        width: 100,
        type:"currency"
        
      }
    ]
  }
};

export default rp605;